import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { theme } from '../../theme';

const ReviewsRating = ({ rating }) => {
    return (
        <Rating
            value={rating}
            readOnly
            precision={0.5}
            size="large"
            sx={{ fontSize: "1.3rem" }}
            icon={<StarIcon sx={{ fontSize: "1.3rem", color: theme.main_code }} />}
            emptyIcon={<StarBorderIcon sx={{ fontSize: "1.3rem", color: "#ccc" }} />}
        />
    );
};

export default ReviewsRating;